import { Link, useLocation } from 'react-router-dom';

import { Card, PageHeader } from '../ui';

/**
 * There is no page at this address.
 *
 * The address is echoed back because most of the ways to land here are a
 * mistyped or truncated link out of an email, and seeing what was actually
 * asked for is what tells somebody the link was cut in half.
 */
export function NotFound(): React.JSX.Element {
  const { pathname } = useLocation();

  return (
    <>
      <PageHeader eyebrow="Nexus" title="Not found" lead="There is no page at this address." />
      <Card>
        <p className="muted">
          Nothing answers at <code className="chip quiet">{pathname}</code>. If you followed a link
          from an email, check it was not cut in half on the way.
        </p>
        <div className="actions">
          <Link className="btn btn-primary" to="/campaigns">
            Campaigns
          </Link>
          <Link className="btn btn-ghost" to="/">
            Back to the start
          </Link>
        </div>
      </Card>
    </>
  );
}
